export const ALFA_ID_CHANNEL = 'auth-alfa-code';
